import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { updateTags } from "../utils/funcs";
import { HSForm } from "../components";

export const HSForms = () => {
    const { formid } = useParams()
    const formNames = {
        "08f272f8-3a4d-489a-b3e8-568a253d9995": "Speaker",
        "c1f17572-8594-4a15-b7ba-9b0ea03a0642": "Judge"
    }
    const formName = `${formNames[formid] || ''}`
    useEffect(() => {
        updateTags(`youngStartup Ventures | ${formName} Form`)
    }, [])

    return (
        <HSForm id={formid} />
    )
}
